import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useCommunityPartnerPayment } from 'Hooks';
import { Colors } from 'Types';
import { paymentStatus, currencyFormatter, getCurrentLocale } from 'Utils';
import { Badge, Card } from 'Elements';
import { Col, Row } from 'reactstrap';
import styles from 'partials/card/subscription-card.module.scss';
import { SkeletonViewPayment } from './SkeletonViewPayment';
import { ListBusinessPartner } from './ListBusinessPartner';

interface Props {
	transactionId: string;
}

export const ViewPayment: FC<Props> = ({ transactionId }) => {
	const { t } = useTranslation();

	const { data, isLoading } = useCommunityPartnerPayment(transactionId);

	const getStatusById = (status: number) => {
		return paymentStatus.find((filter) => filter.value === status);
	};

	function getMonthName(monthNumber, language) {
		const months = {
			en: [
				'January',
				'February',
				'March',
				'April',
				'May',
				'June',
				'July',
				'August',
				'September',
				'October',
				'November',
				'December'
			],
			de: [
				'Januar',
				'Februar',
				'März',
				'April',
				'Mai',
				'Juni',
				'Juli',
				'August',
				'September',
				'Oktober',
				'November',
				'Dezember'
			]
		};
		return months[language][monthNumber - 1];
	}

	return (
		<>
			<Row>
				<Col>
					<Card>
						{isLoading ? (
							<SkeletonViewPayment />
						) : (
							<div className="d-flex" style={{ gap: '100px' }}>
								<div>
									<div className={styles.row}>
										<span className={styles.rowLabel}>
											{t('label.credit-payment-code')}:
										</span>
										<span className="fs-6 text-primary">
											{data?.creditPaymentNumber ?? '---'}
										</span>
									</div>
									<div className={styles.row}>
										<span className={styles.rowLabel}>
											{t('label.total-payment')}:
										</span>
										<span>
											{currencyFormatter(
												data?.totalPaymentAmount ?? 0
											)}
										</span>
									</div>
									<div className={styles.row}>
										<span className={styles.rowLabel}>
											{t('label.total-donated')}:
										</span>
										<span>
											{currencyFormatter(
												data?.totalDonatedAmount ?? 0
											)}
										</span>
									</div>
									<div className={styles.row}>
										<span className={styles.rowLabel}>
											{t('label.status')}:
										</span>
										<Badge
											color={
												getStatusById(data?.status ?? 0)
													?.color ?? Colors.muted
											}>
											{t(
												`${
													getStatusById(
														data?.status ?? 0
													)?.label
												}`
											)}
										</Badge>
									</div>
								</div>
								<div>
									<div className={styles.row}>
										<span className={styles.rowLabel}>
											{t('card.created-date')}:
										</span>
										<div className="d-flex gap-2 fs-sm text-gray-3">
											<span>
												{getMonthName(
													data?.month,
													getCurrentLocale()?.code
												)}
											</span>
											<span>{data?.year}</span>
										</div>
									</div>
								</div>
							</div>
						)}
					</Card>
				</Col>
			</Row>
			<ListBusinessPartner transactionId={transactionId} />
		</>
	);
};
